<template>
    <div class="order-rank-list">
      <div v-for="(item,index) in rankData" v-bind:key="index">
        <rankItem>
          <span class="rank-number" slot="rank-number">{{ item.rankNumber }}</span>
          <span class="product-name" slot="product-name">{{ item.productName }}</span>
          <i slot="icon" class="el-icon-top" style="color: #409EFF" v-if="item.status === 0"></i>
          <i slot="icon" class="el-icon-bottom" style="color: red" v-else-if="item.status === 1"></i>
          <i slot="icon" class="el-icon-minus" style="color:  #E6A23C" v-else></i>
        </rankItem>
      </div>
    </div>
</template>

<script>
import rankItem from './rankItem'
export default {
  name: 'orderRankList',
  data () {
    return {
      rankData: [
        {
          status: -1,
          rankNumber: 1,
          productName: '大闸蟹'
        },
        {
          status: 1,
          rankNumber: 2,
          productName: '大螃蟹'
        }, {
          status: 0,
          rankNumber: 3,
          productName: '小龙虾'
        }, {
          status: 0,
          rankNumber: 4,
          productName: '河蟹'
        }, {
          status: 0,
          rankNumber: 5,
          productName: '螃蟹'
        }
      ]

    }
  },
  components: {
    rankItem
  }
}
</script>

<style scoped>
  .order-rank-list{
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
  }
  .rank-number{
    display: inline-block;
    color: #E6A23C;
    width: 40px;
  }
  .product-name{
    display: inline-block;
    width: 170px;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 120px;
  }
</style>
